import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const REVIEWS = [{
  name: 'Jorge L.',
  country: '🇵🇪 Perú',
  stars: 5,
  text: 'Causa, te juro que esto me cambió la vida pe. Yo estaba recontra pegado al celular, no podía ni dormir tranquilo. Empecé con el Track 1 nomás y ya al tercer día sentí que mi cabeza estaba más despejada. Ahora ya no agarro el celu apenas me despierto, ya pues, eso ya es un montón para mí. Recontra recomendado.'
}, {
  name: 'Marta S.',
  country: '🇪🇸 España',
  stars: 5,
  text: 'Mira, yo era de las que decía "bah, otro libro de autoayuda más" y flipé. Es que es muy diferente, tío. El audio te va guiando y no es nada borde ni pretencioso. Lo escuché en el metro camino al curro y me quedé rallada de lo mucho que me identificaba. Llevo 18 días y la verdad es que mola mogollón. Me siento mucho más centrada.'
}, {
  name: 'Kevin R.',
  country: '🇸🇻 El Salvador',
  stars: 5,
  text: 'Fíjate que yo andaba bien perdido vos, pasaba horas en el teléfono sin hacer nada de provecho. Un compa me pasó el link y dije "va pues, qué pierdo". Mirá, no te voy a mentir, los primeros días cuesta un poco pero ya después le agarrás el modo. Ahorita ya duermo más chivo y me siento más tranquilo. Bien cipote el cambio.'
}, {
  name: 'Daniela M.',
  country: '🇨🇴 Colombia',
  stars: 5,
  text: 'Ay parce, esto es una chimba. Yo llevaba meses sintiéndome toda ansiosa y como sin rumbo, ¿sí me entendés? Mi hermana me lo regaló y al principio pensé "qué pereza" pero uy no, qué nota. El workbook es bacano porque te hace escribir las vainas y ahí es donde uno de verdad se pilla. Llevo 22 días y me siento una berraca. Super recomendado.'
}];
export function ReviewsCarousel() {
  return;
}